import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/login')({
  head: () => noIndexRouteHead('login', 'fr'),
  component: LoginPage,
})
